/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalInstitution from './hospital-institution';
import HospitalInstitutionDetail from './hospital-institution-detail';
import HospitalInstitutionUpdate from './hospital-institution-update';
import HospitalInstitutionDeleteDialog from './hospital-institution-delete-dialog';

const HospitalInstitutionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalInstitution />} />
    <Route path="new" element={<HospitalInstitutionUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalInstitutionDetail />} />
      <Route path="edit" element={<HospitalInstitutionUpdate />} />
      <Route path="delete" element={<HospitalInstitutionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalInstitutionRoutes;
